<template>
  <ais-sort-by :items="items">
    <div slot-scope="{ items, currentRefinement, refine }" class="sort-selector ml-2" ref="container">
      <div
        :class="['flex-1 cursor-pointer', isOpen ? 'text-smurfs-gold' : '']"
        @click="toggle()"
      >
        <span>
          Sort By
          <i class="fas fa-sort-alpha-down"></i>
        </span>
      </div>
      <div v-if="isOpen" :class="['overlay', `overlay--left`]">
        <div class="item-list">
          <div
            v-for="item in items"
            :key="item.value"
            @click.prevent="refine(item.value)"
            :class="['item', item.value === currentRefinement && 'item--selected']"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </ais-sort-by>
</template>

<script>
import { closeOnOutsideClickMixin } from '../../../shared/mixins/closeOnOutsideClickMixin';

export default {
  mixins: [closeOnOutsideClickMixin],

  props: {
    items: Array,
  },

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggle() {
      this.isOpen ? this.close() : this.open();
    },

    open() {
      this.isOpen = true;
      this.listenForOutsideClicks();
    },

    close() {
      this.isOpen = false;
      this.stopListeningForOutsideClicks();
    },
  },
};
</script>

<style lang="scss" scoped>
.sort-selector {
  @apply relative select-none;
  @apply flex items-center;
  @apply h-full;
}

.overlay {
  @apply mt-2;
  @apply bg-10 border border-honestly-white;
  @apply text-honestly-white text-left;
  @apply whitespace-nowrap;
  @apply flex flex-col;
  @apply shadow-md;
  @apply absolute z-50;
  top: 100%;
  min-width: 200px;

  &--left {
    @apply right-0;
  }

  &--right {
    @apply left-0;
  }

  .item-list {
    @apply flex flex-col p-2;
    max-height: 350px;
    overflow-y: auto;

    .item {
      @apply text-sm px-2 py-1;
      @apply bg-almost-black;
      @apply cursor-pointer;

      &:not(:last-child) {
        @apply mb-2;
      }

      &--selected {
        @apply bg-smurfs-gold text-honestly-white;
      }
    }
  }
}
</style>
